import { ICancelOrder, IConfirmOrder, IEditOrder, IGetOrderByDevice, IOrder, IPlan } from '~/utils/interface/order';
import axiosClient from './axiosClient';

const orderApi = {
  getByDevice(params: IGetOrderByDevice) {
    return axiosClient.get<IOrder[]>(`/api/order/get-by-device`, { params });
  },
  getPlans() {
    return axiosClient.get<IPlan[]>(`/api/order/get-avaiable-plan`);
  },
  confirmOrder(data: IConfirmOrder) {
    return axiosClient.post<string>(`/api/order/admin-confirm-payment`, data);
  },
  cancelOrder(data: ICancelOrder) {
    return axiosClient.post<string>(`/api/order/admin-cancel-payment`, data);
  },
  updateEInvoiceFile(data: IEditOrder) {
    return axiosClient.post<IOrder>('api/order/update-einvoice-files', data);
  },
};

export default orderApi;
